import { useMemo } from 'react'

import { useTranslation } from 'services/i18n'

import { Conversation } from 'types/Api'

import { ConversationsGroupAccordion } from './ConversationsGroupAccordion'
import { getGroupedConversationSortedByDate } from './utils'

import type { ComponentProps, FC } from 'react'

type Props = {
  conversations: Conversation[]
} & Omit<ComponentProps<typeof ConversationsGroupAccordion>, 'conversations' | 'title'>

export const UnpinnedConversations: FC<Props> = ({
  activeConversationId,
  conversations,
  onSelectConversation,
  onClickDeleteConversation,
  onTriggerEvent,
}) => {
  const { t } = useTranslation()

  const groupedUnpinnedConversations = useMemo(
    () =>
      getGroupedConversationSortedByDate(conversations),
    [conversations],
  )

  return (
    <>
      {Object.entries(groupedUnpinnedConversations).map(
        ([groupTitle, unpinnedConversations]) => (
          <ConversationsGroupAccordion
            key={groupTitle}
            title={groupTitle}
            showTooltips={groupTitle === t('conversation_history.more_than_60_days')}
            conversations={unpinnedConversations}
            activeConversationId={activeConversationId}
            onSelectConversation={onSelectConversation}
            onClickDeleteConversation={onClickDeleteConversation}
            onTriggerEvent={onTriggerEvent}
          />
        ),
      )}
    </>
  )
}
